import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

export default function SuccessModal({ isOpen, applicationId, onClose }) {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8"
        >
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <Icon name="CheckCircle" size={48} color="#10B981" />
            </div>
          </div>

          {/* Content */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Registration Submitted Successfully!
            </h2>
            <p className="text-gray-600 mb-4">
              Thank you for completing your registration. Your application has been submitted and is now under review.
            </p>
            
            {/* Application ID */}
            {applicationId && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-1">Your Application ID:</p>
                <p className="text-xl font-mono font-bold text-blue-600">
                  {applicationId}
                </p>
                <p className="text-xs text-gray-600 mt-2">
                  Please save this ID for future reference
                </p>
              </div>
            )}

            {/* Important Information */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4 text-left">
              <div className="flex items-start gap-2">
                <Icon name="AlertCircle" size={20} color="#F59E0B" className="flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-gray-900 mb-1">Important:</p>
                  <p className="text-sm text-gray-700">
                    A confirmation email has been sent to your registered email address. 
                    Please check your inbox and verify your email to complete the registration process.
                  </p>
                </div>
              </div>
            </div>

            {/* Next Steps */}
            <div className="text-left bg-gray-50 rounded-lg p-4">
              <p className="text-sm font-semibold text-gray-900 mb-2">Next Steps:</p>
              <ol className="text-sm text-gray-700 space-y-1 list-decimal list-inside">
                <li>Check your email inbox for verification link</li>
                <li>Complete email verification</li>
                <li>Set up your account password</li>
                <li>Track your application status in the employee portal</li>
              </ol>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              onClick={onClose}
              variant="primary"
              className="w-full"
              iconName="ArrowRight"
            >
              Go to Employee Portal
            </Button>
            <Button
              onClick={() => window.location.href = '/'}
              variant="outline"
              className="w-full"
            >
              Return to Home
            </Button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}